import React, { useState } from 'react'
import { Modal, Button, Form, Select, DatePicker } from 'antd'
import PropTypes, { array, arrayOf, number, shape, string } from 'prop-types'
import styled from 'styled-components'
import moment from 'moment'

const StepModal = ({
	showModal,
	handleCancel,
	handleSave,
	steps,
	current_step_id,
	groupsList,
}) => {
	const [form] = Form.useForm()
	const { Option } = Select
	const [selectedResponsibleGroup, setSelectedResponsibleGroup] = useState(
		steps[current_step_id].responsible_group
	)

	const initialDate =
		current_step_id >= 0 ? steps[current_step_id].due_date : ''

	const groupOptions = groupsList.map((group) => (
		<Option key={group.id}>{group.name}</Option>
	))

	const onResponsibleGroupSelected = (value, selectedOption) => {
		setSelectedResponsibleGroup({
			id: selectedOption.key,
			name: selectedOption.children,
		})
	}

	const getFooterModal = () => (
		<div
			style={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'flex-end',
			}}>
			<Button key="cancelar" onClick={handleCancel} size="large">
				Cancelar
			</Button>
			<Button
				key="salvar"
				onClick={() => {
					const updatedStep = {}
					if (form.isFieldTouched('dueDate')) {
						updatedStep['dueDate'] = form.getFieldValue('dueDate').toISOString()
					}

					if (form.isFieldTouched('group')) {
						updatedStep['responsible_group'] = selectedResponsibleGroup
					}

					if (form.isFieldsTouched()) {
						handleSave(updatedStep)
					} else {
						handleCancel()
					}
				}}
				type="primary"
				size="large"
				style={{ marginLeft: 30 }}>
				Confirmar
			</Button>
		</div>
	)

	return (
		<StyledModal open={showModal} closable={false} footer={null} width={460}>
			<NewDivider />
			<Form
				form={form}
				hideRequiredMark
				id="stepForm"
				layout="horizontal"
				initialValues={{
					group: String(selectedResponsibleGroup?.id),
					dueDate: moment(initialDate),
				}}>
				{selectedResponsibleGroup && (
					<StyledItemForm label="Grupo responsável" name="group">
						<Select
							mode="single"
							style={{ width: '90%' }}
							placeholder="Selecione o grupo"
							onSelect={onResponsibleGroupSelected}>
							{groupOptions}
						</Select>
					</StyledItemForm>
				)}

				{initialDate && (
					<StyledItemForm label="Prazo" name="dueDate">
						<DatePicker
							allowClear={false}
							format={'DD/MM/YYYY'}
							disabledDate={(pickerDate) => pickerDate < moment().endOf('day')}
						/>
					</StyledItemForm>
				)}
				<NewDivider />
				{getFooterModal()}
			</Form>
		</StyledModal>
	)
}

StepModal.propTypes = {
	handleCancel: PropTypes.func,
	handleSave: PropTypes.func,
	showModal: PropTypes.bool,
	steps: arrayOf(
		shape({
			title: string.isRequired,
			due_date: string,
			responsible_group: string,
			approved_by: string,
			approved_at: string,
		})
	).isRequired,
	current_step_id: number,
	groupsList: array,
	users: array,
}

export default StepModal

const NewDivider = styled.div`
	background: rgba(0, 0, 0, 0.25);
	height: 0.8px;
	margin: 28px 0;
`

const StyledItemForm = styled(Form.Item)`
	.ant-form-item-label {
		padding: 0;
	}
`

const StyledModal = styled(Modal)`
	.ant-modal-body {
		padding: 28px;
	}
`
